import SliderNormal from './SliderNormal';
import SliderTrim from './SliderTrim';

// istanbul ignore next
export const Slider = {
  Normal: SliderNormal,
  Trim: SliderTrim,
};

// istanbul ignore next
export default Slider;
